






































































import Vue from "vue";
import { mapState, mapMutations } from "vuex";
export default Vue.extend({
  name: "TenantSelect",
  props: {
    isCollapse: { type: Boolean }
  },
  data() {
    return {
      dialog: false
    };
  },
  computed: {
    ...mapState("LoginInfo", ["userinfo", "tenantId"]),
    tenant() {
      if (!this.userinfo) return "";
      return this.userinfo.tenants.find(
        (item: any) => item.id === this.tenantId
      );
    }
  },
  watch: {
    tenantId(val) {
      this.$router.push({ name: "TanOverview", params: { tenantId: val } });
    }
  },
  methods: {
    ...mapMutations("LoginInfo", {
      change: "SET_TENANT_ID"
    }),
    showTenant() {
      // @ts-ignore
      this.dialog = true;
      setTimeout(() => {
        // @ts-ignore
        document.addEventListener("click", this.closeTenant);
      }, 200);
    },
    closeTenant() {
      // @ts-ignore
      this.dialog = false;
      // @ts-ignore
      document.removeEventListener("click", this.closeTenant);
    }
  }
});
